import { render } from "./PromocodeGenerate.vue?vue&type=template&id=13192b02&scoped=true"
import script from "./PromocodeGenerate.vue?vue&type=script&lang=js"
export * from "./PromocodeGenerate.vue?vue&type=script&lang=js"

import "./PromocodeGenerate.vue?vue&type=style&index=0&id=13192b02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13192b02"

export default script